<template>
  <v-slide-item>
    <v-chip class="detail-chip-tag mr-1" :style="`color: ${invertColor(tagInfo.color)};`" :color="tagInfo.color" variant="elevated" label>
      {{ tagInfo.title }}
    </v-chip>
  </v-slide-item>
</template>

<script>
import {TagInfo} from "@/mixins/tags.js";
import Helpers from "@/mixins/helpers.js";

export default {
  name: "Tag",

  mixins: [Helpers],

  props: {
    tagInfo: TagInfo,
  },
};
</script>

<style scoped>
.detail-chip-tag {
  --tag-count-in-container: 0;
  /* size */
  width: 100%;
  min-width: max-content;
  max-width: max-content;
  /* behavior */
  display: flex;
  /* flex-properties */
  justify-content: center;
  flex: 1 1 calc(100% / var(--tag-count-in-container));
}
</style>

<style global>
.tag-container {
  /* variables */
  --tag-count: 0;
  /* behavior */
  overflow-x: auto;
  display: flex;
  gap: 8px;
}

.tag-container::-webkit-scrollbar {
  display: none;
}

.tag-container > * {
  /* flex properties */
  flex: 0 0 calc(100% / var(--tag-count));
}
</style>
